import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MomentModule } from 'ngx-moment';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { DropdownModule } from 'primeng/dropdown';
import { TreeTableModule } from 'primeng/treetable';
import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { MultiSelectModule } from 'primeng/multiselect';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ReactiveValidationModule } from 'angular-reactive-validation';

import {
    MD5Pipe,
    TraversePipe,
    UrlEncodePipe,
    SlugToTitlePipe,
    FormErrorComponent,
    PaginationComponent,
    AddressFormComponent,
    UnderscoreToHyphenPipe,
    UserInfoTooltipComponent,
    LoadingIndicatorComponent,
    ControlledByMagayaWarningComponent,
} from '@qwyk/ui-standalone';
import { HubAdministrationPortalTeamsStateModule } from '@qwyk/hub/administration/data-access/portal-teams';
import { HubAdministrationCustomerUsersStateModule } from '@qwyk/hub/administration/data-access/customer-users';

import {
    CustomerUserCreateComponent,
    CustomerUserDetailComponent,
    CustomerUserImpersonateModalComponent,
    CustomerUserPermissionsComponent,
    CustomerUsersListComponent,
    CustomerUsersListWidgetComponent,
    CustomerUserViewComponent,
    SearchMagayaEntityListComponent,
    SearchMagayaEntityModalComponent,
} from './components';

import { CustomerUserStatusBadgeComponent } from './components/customer-user-status-badge/customer-user-status-badge.component';

@NgModule({
    imports: [
        CommonModule,
        MD5Pipe,
        TableModule,
        FormsModule,
        RouterModule,
        MomentModule,
        TraversePipe,
        UrlEncodePipe,
        TooltipModule,
        NgSelectModule,
        DropdownModule,
        SlugToTitlePipe,
        TreeTableModule,
        TranslateModule,
        FontAwesomeModule,
        MultiSelectModule,
        FormErrorComponent,
        PaginationComponent,
        ReactiveFormsModule,
        AddressFormComponent,
        UnderscoreToHyphenPipe,
        UserInfoTooltipComponent,
        ReactiveValidationModule,
        LoadingIndicatorComponent,
        ControlledByMagayaWarningComponent,
        HubAdministrationPortalTeamsStateModule,
        HubAdministrationCustomerUsersStateModule,
    ],
    declarations: [
        CustomerUsersListComponent,
        CustomerUserViewComponent,
        CustomerUserDetailComponent,
        CustomerUsersListWidgetComponent,
        CustomerUserCreateComponent,
        CustomerUserImpersonateModalComponent,
        CustomerUserStatusBadgeComponent,
        SearchMagayaEntityModalComponent,
        SearchMagayaEntityListComponent,
        CustomerUserPermissionsComponent,
    ],
    providers: [MD5Pipe, UrlEncodePipe],
    exports: [CustomerUsersListWidgetComponent],
})
export class HubAdministrationCustomerUsersWithoutRoutingModule {}
